import CourseDetailInnerRender from '@/components/elements/course/CourseDetailInnerRender';
import { PATH_NAME } from '@/configs/pathName';
import { getFirst150Characters } from '@/helpers/stringHelpers';
import { useSEO } from '@/hooks/useSEO';
import { ICourseDetailResponse } from '@/interfaces/training.interface';
import { NextPageWithLayout } from '@/pages/page';
import { getCourseDetails } from 'apis/tms/course.api';
import cookieCommons from 'common/cookieCommons';
import BaseLayout from 'layouts';
import { GetServerSideProps } from 'next';
import CourseDetailPermissionProvider from 'state/course/CourseDetailPermissionProvider';

const CourseDetail: NextPageWithLayout<{ data: ICourseDetailResponse }> = ({
  data,
}) => {
  return (
    <CourseDetailPermissionProvider data={data}>
      <CourseDetailInnerRender />
    </CourseDetailPermissionProvider>
  );
};

export default CourseDetail;
CourseDetail.getLayout = (page) => <BaseLayout>{page}</BaseLayout>;

export const getServerSideProps: GetServerSideProps = async (context) => {
  cookieCommons.setContext(context);
  const { cid: courseId } = context.query;

  try {
    const data = await getCourseDetails(courseId as string);

    const seo = await JSON.parse(
      JSON.stringify(
        useSEO(data?.title + '', {
          description: getFirst150Characters(data?.description + ''),
        })
      )
    );
    return {
      props: {
        data,
        seo,
      },
    };
  } catch (error) {
    return {
      redirect: {
        destination: PATH_NAME.NOT_FOUND,
        permanent: false,
      },
    };
  }
};
